export class StripeCoupon {
  Id: string;
  AmountOff: number;
  DateTime: Date;
  Currency: string;
  Duration: string; // "forever", "once", "repeating"
  DurationInMonths: number;
  MaxRedemptions: number;
  PercentOff: number;
  RedeemBy: Date;
  TimesRedeemed: number;
  Valid: boolean;
  Active: boolean;

  constructor(obj?: any) {
    this.Id = (obj && obj.Id) || '';
    this.AmountOff = (obj && obj.AmountOff) || 0;
    this.DateTime = (obj && obj.DateTime) || null;
    this.Currency = (obj && obj.Currency) || '';
    this.Duration = (obj && obj.Duration) || '';
    this.DurationInMonths = (obj && obj.DurationInMonths) || 0;
    this.MaxRedemptions = (obj && obj.MaxRedemptions) || 0;
    this.PercentOff = (obj && obj.PercentOff) || 0;
    this.RedeemBy = (obj && obj.RedeemBy) || null;
    this.TimesRedeemed = (obj && obj.TimesRedeemed) || 0;
    this.Valid = (obj && obj.Valid) || false;
    this.Active = (obj && obj.Active) || false;
  }
}

export class StripeTransaction {
  //User: User;
  Token: any; // token from stripe
}

export class StripeCustomer {
  CardBrand: string;
  CardLast4: string;
}
